<template>
  <div
    :id="point._id"
    :class="['point', isActive ? 'active' : 'deactive']"
    @dblclick="viewDetail"
  >
    <p>
      <break-word-span :text="name" :maxLength="15"></break-word-span>
    </p>
    <button
      v-if="!isEndPoint"
      class="btn btn-update_node btn-add_node"
      name="addNode"
      @click="addNode"
    >
      Thêm node
    </button>
    <button
      v-if="!isEndPoint"
      class="btn btn-update_node btn-add_node"
      name="addLine"
      @click="addLine"
    >
      Thêm line
    </button>
  </div>
</template>

<script>
  import constants from "../../../constants";
  import cauHinhLuongUtils from "../../../services/cauhinhluong/cauHinhLuongUtils";
  import BreakWordSpan from "../../adminstration/ketluan/break-word-span";
  import VbFlowDetailDialog from "./vb-flow-detail-dialog";
  import VbStepOutgoingDetailDialog from "./vb-step-detail-dialog";

  export default {
    name: "point",
    components: {BreakWordSpan, VbStepOutgoingDetailDialog, VbFlowDetailDialog},
    props: ["point"],

    data() {
      return {
        name: null
      };
    },

    computed: {
      isEndPoint() {
        return cauHinhLuongUtils.isEndPoint(this.point);
      },
      isStartPoint() {
        return cauHinhLuongUtils.isStartPoint(this.point);
      },
      isActive() {
        return (
          this.isEndPoint ||
          this.isStartPoint ||
          this.point.vbStepForm.status === constants.STATUS_.ACTIVE
        );
      }
    },

    created() {
      this.initComponent();
    },

    methods: {
      viewDetail() {
        if (!this.isEndPoint && !this.isStartPoint)
          this.$emit("viewDetail", {point: this.point});
      },

      addNode() {
        this.$emit("addNode", {point: this.point});
      },

      addLine() {
        this.$emit("addLine", {point: this.point});
      },

      initComponent() {
        switch (this.point.type) {
          case constants.CAU_HINH_LUONG_PAGE.POINT.TYPE.START:
            return (this.name = "Bắt đầu");
          case constants.CAU_HINH_LUONG_PAGE.POINT.TYPE.END:
            return (this.name = "Kết thúc");
          default:
            return (this.name = this.point.vbStepForm.stepName);
        }
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/setting/cau-hinh-luong-v2/point.vue